<form data-abide [formGroup]="editNameServersForm" (ngSubmit)="onSubmit()" name="editNSForm" novalidate>
  <div *ngIf="minimumNSRequirement" class="callout alert is-closable">
    <p>Minimum two name servers are required.</p>
  </div>

  <div class="grid-x">
    <div class="cell large-4 medium-6 small-12 content-header cell-margin-right" style="padding-left: 24px">Host name (e.g. ns1.example.com)</div>
    <div class="cell large-6 medium-6 small-12 content-header cell-margin-right">IP addresses (e.g. 192.0.2.5, 2001:db8::2:5)</div>
    <div class="cell auto content-header"></div>
  </div>
  <div formArrayName="nameservers">
    <div *ngFor="let formNameServer of formNameServers.controls; let i=index;">
      <div class="grid-x">
        <div class="cell large-4 medium-6 small-12 cell-margin-right" [formGroupName]="i">
            <fa-icon
                    (click)="removeNameServer(i)" [disabled]="!(nameServers[i]| valueFromMap: serverConstants.LOCK_FIELD_NAME: 'DELETE' | checkNull)"
                    [icon]="'trash'"
                    class="delete-icon align-center cell-margin-right" style="display: inline">
            </fa-icon>
            <input ngClass="{{checkIfHostErrorForCSS(formNameServer, i)}}" type="text"
                   formControlName="host" (focus)="onHostFocus(i, formNameServer)" (blur)="onHostBlur(i)" maxlength="100">
            <div class="form-error is-visible" *ngIf="!formNameServer.valid && formNameServer.get('host').touched">
              <span *ngIf="checkIfHostError(formNameServer.get('host').errors)">Invalid Host Name</span>
            </div>
          <div class="form-error is-visible"
               *ngIf="hostValidationError(formNameServer.get('host').value, i).length > 0">
            <div *ngFor="let error of hostValidationError(formNameServer.get('host').value, i)">
              {{error}}
            </div>
          </div>
          <div class="form-error is-visible" *ngIf="blurHostErrors.get(i)?.length > 0">
            <div *ngFor="let error of blurHostErrors.get(i)">{{error}}</div>
          </div>

        </div>
        <div class="cell auto cell-margin-right" [formGroupName]="i">
          <input ngClass="{{checkIfIPErrorForCSS(formNameServer)}}" type="text"
                 formControlName="ip" (focus)="formNameServer.get('ip').markAsUntouched()" maxlength="100">
          <div class="form-error is-visible" *ngIf="!formNameServer.valid && formNameServer.get('ip').touched">
            <span *ngIf="checkIfIPError(formNameServer.get('ip').errors)">Invalid Ip Address-{{formNameServer.get('ip').errors.invalidIpAddress}}</span>
          </div>
          <div class="form-error is-visible"
               *ngIf="IPValidationError(formNameServer.get('host').value, i).length > 0">
            <div *ngFor="let error of IPValidationError(formNameServer.get('host').value, i)">
              {{error}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <a class="a-link" (click)="addAditionalNS()">Add new name server</a>

  </div>
  <div class="grid-x save-cancel-button-group">
    <button class="iana-button-cancel" (click)="cancel()">{{newDelegation ? "Previous" : "Cancel"}}</button>
    <button class="iana-button" [disabled]="!editNameServersForm.valid || blurHostErrors.size > 0" type="submit">{{newDelegation ? "Next" : "Save"}}</button>
  </div>

</form>
